module.exports = __webpack_public_path__ + "static/media/mars-4.4e4a0a6a.jpg";